export default choice => choice === 1 ? 0 : 1
